import { routerApp } from '../app.module';
import { getCacheBustedTemplate } from '../app.route';
import { ALLOWED_DOCUMENT_ACCEPT, ALLOWED_DOCUMENT_TYPES_INFO } from '../utils/document-file-types';

routerApp.directive('fileUpload', function() {
    return {
        templateUrl: getCacheBustedTemplate('pages/directives/file-upload.html'),
        scope: {
            uploadType: '@',
            label: '@',
            warningTooltip: '@',
            deletePrompt: '@',
            files: '=',
            canUpload: '<',
            warnWhen: '<',
            onUpload: '&',
            onDelete: '&',
        },
        link: function(scope) {
            scope.allowedDocumentTypes = ALLOWED_DOCUMENT_ACCEPT;
            scope.allowedDocumentTypesInfo = ALLOWED_DOCUMENT_TYPES_INFO;
        },
    }
});
